import FormField from 'components/community/common/FormField';
import React from 'react';
import { CHAR_LIMIT_MAP } from '../validations';

export default function SupportEmail({
    formData,
    errors,
    pageMode = false,
    label = 'Organizer email',
    ...rest
}) {
    return (
        <FormField
            id='supportEmail'
            name='supportEmail'
            label={label}
            placeholder='Organized by'
            filledValue={formData.supportEmail}
            isError={errors.supportEmail}
            errorMsg={errors.supportEmail}
            maxLength={CHAR_LIMIT_MAP['supportEmail']?.max}
            variant='v2'
            inputValue={pageMode ? formData?.supportEmail : null}
            value={formData?.supportEmail}
            {...rest}
        />
    );
}
